// extracted by mini-css-extract-plugin
export default {"container":"Brands_container__2-oXl"};